import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './styles/Navbar.css';
import logo from './images/alwifak.png';
import { getDocs, collection } from 'firebase/firestore';
import { db } from '../../firebase'; // Ensure you have the correct path to your Firebase configuration

const menuData = [
  { name: 'Accueil', path: '/' },
  { name: 'Actualités', path: '/lesActualites' },
  { 
    name: 'Nos projets', 
    submenu: [
      { name: 'Projets réalisés', path: '/projets-realises' },
      { name: 'Projets en cours', path: '/projets-en-cours' }
    ]
  },
  { 
    name: 'Recrutement', 
    submenu: [
      { name: 'Staff', path: '/recrutementStaff' },
      { name: 'Consultants', path: '/recrutementConsultant' }
    ]
  },
  { 
    name: 'Statistiques', 
    submenu: [
      { name: 'Par secteur', path: '/voirstatistiquesparsecteur'},
      { name: 'Par genre', path: '/voirstatistiquespargenre' }
    ]
  },
  { name: 'FAQ', path: '/faq' },
  { name: 'Contact', path: '/contact' }
];

const Navbar = () => {
  const [activeMenu, setActiveMenu] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [totalJobOffers, setTotalJobOffers] = useState(0);


  const handleMouseEnter = (menu) => {
    setActiveMenu(menu);
  };

  const handleMouseLeave = () => {
    setActiveMenu(null);
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  // Fetch job offers and counts
  useEffect(() => {
    const fetchJobOffers = async () => {
      try {
        const [consultantSnapshot, staffSnapshot] = await Promise.all([
          getDocs(collection(db, 'job_consultant')),
          getDocs(collection(db, 'job_staff'))
        ]);

        const consultantCount = consultantSnapshot.size;
        const staffCount = staffSnapshot.size;
        setTotalJobOffers(consultantCount + staffCount);

      } catch (error) {
        console.error("Erreur lors de la récupération des offres d'emploi : ", error);
      }
    };

    fetchJobOffers();
  }, []);

  return (
    <nav className='nav'>
      <a className='nav__logo' onClick={() => window.location.href = '/'}>
        <img src={logo} alt="Home" />
      </a>
      <button className='nav__toggle' onClick={toggleMenu}>
        ☰
      </button>
      <div className={`nav__menu ${menuOpen ? 'active' : ''}`}>
        <ul>
          {menuData.map((item, index) => (
            <li 
              key={index}
              className='nav__dropdown'
              onMouseEnter={() => item.submenu && handleMouseEnter(item.name)}
              onMouseLeave={() => item.submenu && handleMouseLeave()}
              onClick={() => item.submenu && handleMouseEnter(item.name)}
            >
              <Link to={item.path || '#'} className='nav__link'>
                {item.name}
                {/* Conditionally render the notification count */}
                {item.name === 'Recrutement' && totalJobOffers > 0 && (
                  <span className='nav__counts'>
                    {totalJobOffers}
                  </span>
                )}
              </Link>
              {item.submenu && activeMenu === item.name && (
                <ul className='nav__dropdown-menu'>
                  {item.submenu.map((subItem, subIndex) => (
                    <li key={subIndex}>
                      <Link to={subItem.path} className='nav__link'>
                        {subItem.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
